<template>
  <span>

    <v-btn 
      depressed 
      color     = "primary" 
      class     = "pa-6" 
      @click    = "onOpenBrowser()"
    >
      BROWSE
    </v-btn>

    <v-navigation-drawer 
      class     = "drawer" 
      v-model   = "isFileBrowserOpen" 
      temporary 
      :width    = "drawerWidth"
    >
      <div class="drawer-content">

        <!-- Explorer -->
        <FileExplorer
          ref                   = "fileExplorer"
          :played-videos-list   = "history.history"
          :height               = "explorerHeight"
          @path                 = "onSinglePathSelected"
          @paths                = "onMultiplePathsSelected"
        >

          <!-- Toggle Quick View -->
          <template v-slot:quickView>
            <v-btn 
              icon 
              :color      = "ui.isQuickViewEnabled ? 'primary' : 'default'" 
              @click      = "onToggleQuickView"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>

        </FileExplorer>

        <!-- Quick View -->
        <QuickView 
          v-if    = "ui.isQuickViewEnabled" 
          class   = "mt-4" 
          @input  = "onQuickViewSelection"
        >
        </QuickView>

      </div>
    </v-navigation-drawer>
  </span>
</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import FileExplorer from '../../file-explorer/FileExplorer';
import QuickView from './QuickView';
import {
  START_QUICKVIEW,
  STOP_QUICKVIEW
} from '@/utils/action-types';
import {
  SET_FILE_BROWSER_IS_OPEN,
  SET_QUICKVIEW_IS_ENABLED
} from '@/utils/mutation-types';
import { PATH_TYPE } from '@/utils/constants';

// #endregion Imports

export default {

  // #region Properties

  name:     'FileSelector',
  computed: {
    ...mapState([
      'history',
      'ui'
    ]),
    drawerWidth() {
      return this.ui.isQuickViewEnabled ? '100%' : '1150px';
    },
    explorerHeight() {
      return (window.innerHeight - 90) + 'px';
    },
    isFileBrowserOpen: {
      get() {
        return this.ui.isFileBrowserOpen;
      },
      set(isOpen) {
        this.$store.commit(SET_FILE_BROWSER_IS_OPEN, isOpen);
        if (!isOpen) {
          this.$store.dispatch(STOP_QUICKVIEW);
        }
      }
    }
  },
  components: {
    FileExplorer,
    QuickView
  },

  // #endregion Properties

  // #region Events

  methods: {

    onOpenBrowser() {
      this.$store.commit(SET_FILE_BROWSER_IS_OPEN, true);
    },

    onSinglePathSelected(path, type) {
      // Quickview is only for direct selections.
      if (
        (this.ui.isQuickViewEnabled) &&
        (type === PATH_TYPE.VIDEO)
      ) {
        this.$store.dispatch(START_QUICKVIEW, path);
        return;
      }
      this.$emit(
        'input',
        {
          path: path,
          type: type
        }
      );

      this.$refs.fileExplorer.endItemLoading();
    },

    onMultiplePathsSelected(paths) {
      this.$emit(
        'input',
        {
          videoPath:     paths.videoPath,
          subtitlesPath: paths.subtitlesPath,
          type:          'multi'
        }
      );

      this.$refs.fileExplorer.endItemLoading();
    },

    onToggleQuickView() {
      if (this.ui.isQuickViewEnabled) {
        this.$store.dispatch(STOP_QUICKVIEW);
      }

      this.$store.commit(SET_QUICKVIEW_IS_ENABLED, !this.ui.isQuickViewEnabled);
    },

    onQuickViewSelection(path) {
      this.$emit(
        'input',
        {
          path: path,
          type: 'video'
        }
      );

      this.$refs.fileExplorer.endItemLoading();
    }

  }

  // #endregion Events

}
</script>

<style scoped lang="scss">
.drawer {
  top: 56px !important;
  height: calc(100vh - 56px) !important;
  position: fixed;

  .drawer-content {
    display: grid;
    grid-template-columns: 1150px 1fr;
  }
}
</style>
